interface SsoButtonProps {
  provider: string;
  onClick: () => void;
  busy: boolean;
  error: string | null;
}

/**
 * The primary way in: one button that hands off to the organisation's own sign-in screen.
 *
 * There is deliberately no username or password field here. The admin console never sees a
 * credential — the identity provider does — which is why this component takes no input at all.
 */
export function SsoButton({ provider, onClick, busy, error }: SsoButtonProps): JSX.Element {
  return (
    <div className="sso-signin">
      <button type="button" className="button button--primary" onClick={onClick} disabled={busy}>
        {busy ? "Signing in…" : `Sign in with ${provider}`}
      </button>
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
